var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"Feedback",attrs:{"variant":_vm.variant,"dismissible":_vm.dismissible,"fade":""},on:{"dismissed":_vm.handleDismissed},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.message))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }